import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/qq.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)


interface FloatingContactProps {
  avatar: string;
  title: string;
  qq: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingContact',
  props: {
    avatar: null,
    title: null,
    qq: null
  },
  setup(__props: any) {

const props = __props as {
  avatar: string;
  title: string;
  qq: string;
}



const onClick = () => {
  window.open(`https://wpa.qq.com/msgrd?v=3&uin=${props.qq}&site=qq&menu=yes&jumpflag=1`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container),
    onClick: onClick
  }, [
    _createElementVNode("img", {
      src: __props.avatar,
      alt: "",
      class: _normalizeClass(_ctx.$style.avatar)
    }, null, 10, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.wrapper)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.title)
      }, [
        _hoisted_2,
        _createTextVNode(_toDisplayString(__props.title), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.text)
      }, "服务时间 00:00-23:59", 2)
    ], 2)
  ], 2))
}
}

})